import { gql } from "@apollo/client";

export const updateTimeSheetMutation = gql`
mutation($input: TimeSheetInput!){
  updateTimeSheet(input: $input) {
    message
    response
  }
}
`;